import { create } from 'zustand';
import { CaseNote } from '@/api/apis/case';
import { createSelectors } from '@/utils/helpers';

type CaseNotesState = {
  drawerOpened: boolean;
  createNote: boolean;
  editNote: CaseNote | null;
  removeNote: CaseNote | null;
  setDrawerOpened: (data: boolean) => void;
  setCreateNote: (data: boolean) => void;
  setEditNote: (note: CaseNote | null) => void;
  setRemoveNote: (note: CaseNote | null) => void;
};

const useCaseNotesStoreBase = create<CaseNotesState>()((set) => ({
  drawerOpened: false,
  createNote: false,
  editNote: null,
  removeNote: null,
  setDrawerOpened: (drawerOpened) => set({ drawerOpened, createNote: false, editNote: null, removeNote: null }),
  setCreateNote: (openCreate) => set({ drawerOpened: true, createNote: openCreate, editNote: null, removeNote: null }),
  setEditNote: (note) => set({ drawerOpened: true, createNote: false, editNote: note, removeNote: null }),
  setRemoveNote: (note) => set({ drawerOpened: true, createNote: false, editNote: null, removeNote: note }),
}));

export const useCaseNotesStore = createSelectors(useCaseNotesStoreBase);
